import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";
const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};
export const eliveryOrderOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  size: "mini",
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  viewBtn: false,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "代理商",
      prop: "rootDepartId",
      dicData: [],
      type: "select",
      search: true,
      hide: true,
      editVisdiplay: false,
    },
    {
      label: "类型",
      prop: "type",
      dicData: DIC.PURE_OR_PROOF,
      editVisdiplay: false,
    },
    {
      label: "前仓",
      prop: "warehouseName",
      type: "input",
      search: true,
      formsolt: true,
      editVisdiplay: true,
      span: 12,
    },
    {
      label: "前仓电话",
      prop: "warehouseMobile",
      type: "input",
      span: 12,
      editVisdiplay: false,
    },
    {
      label: "客户姓名",
      prop: "customName",
      span: 12,
      search: true,
      type: "input",
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "客户电话",
      prop: "customMobile",
      span: 24,
      search: true,
      type: "input",
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "客户地址",
      prop: "customAddress",
      span: 24,
      search: true,
      editVisdiplay: false,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "产品名称",
      prop: "productName",
      type: "input",
      editVisdiplay: false,
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "提货人",
      prop: "realName",
      formsolt: true,
      type: "input",
      addVisdiplay: false,
      editVisdiplay: true,
    },
    {
      label: "提货人电话",
      prop: "engineerMobile",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
      // search: true,
    },
    // 提货照片
    {
      label: "提货照片",
      prop: "consigneeSignPic",
      span: 24,
      overHidden: true,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
      formsolt: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      //overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      solt: true,
      // dicData: DIC.DELIVERY_ORDER_STATUS,
      editVisdiplay: false,
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 开始时间-结束时间范围搜索

    {
      label: "开始时间",
      prop: "installTimeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "installTimeEnd",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
